export enum TransactionTypoeV2 {
    FACILITY = "FB",
    SPORTPASS = "SP",
    EVENT = "ET",
    COACH = "PC",
    PACKAGE = "PK",
    PROGRAM = "PG",
} 